import FalseInputSearch from "./FalseInputSearch"

const LegacyData = ({data, label, folder, fieldsData, clickHandler, isLoading}) => {

    if (label == 'case_manager' && data?.case_manager_name_legacy && !data?.case_manager) {
        return <FalseInputSearch label={'Legacy Case Manager'} value={data?.case_manager_name_legacy} minWidth={250} action={clickHandler} isLoading={isLoading}/>
    }
    if (folder == 'liabilities' && data?.adjuster_name_legacy && !data?.adjuster) {
        return <FalseInputSearch label={'Legacy Adjuster'} value={data?.adjuster_name_legacy} minWidth={250} action={clickHandler} isLoading={isLoading}/>
    }
    if (folder == 'mp_pip_um' && data?.mp_adjuster_name_legacy && !data?.mp_adjuster) {
        return <FalseInputSearch label={'Legacy MP Adjuster'} value={data?.mp_adjuster_name_legacy} minWidth={250} action={clickHandler} isLoading={isLoading}/>
    }
    if (folder == 'um_pip_um' && data?.um_adjuster_name_legacy && !data?.um_adjuster) {
        return <FalseInputSearch label={'Legacy UM Adjuster'} value={data?.um_adjuster_name_legacy} minWidth={250} action={clickHandler} isLoading={isLoading}/>
    }
    if (folder == 'worker_comp' && data?.adjuster_name_legacy && !data?.adjuster) {
        return <FalseInputSearch label={'Legacy Adjuster'} value={data?.adjuster_name_legacy} minWidth={250} action={clickHandler} isLoading={isLoading}/>
    }

    return <FalseInputSearch label={fieldsData.inputLabel} value={null} minWidth={250} action={clickHandler} isLoading={isLoading}/>
}

export default LegacyData